import { useState, useEffect } from "react";

import Cookies from "js-cookie";
import { Collapse, CollapseProps, Tooltip } from "antd";
import {BookOutlined, GithubOutlined, DockerOutlined, SettingOutlined, GitlabOutlined} from '@ant-design/icons';
import './SideBar.css';

const text = `
  A dog is a type of domesticated animal.
  Known for its loyalty and faithfulness,
  it can be found as a welcome guest in many households across the world.
`;

const items: CollapseProps['items'] = [
    {
        key: '1',
        label: 'Projects',
        children: <p>{text}</p>,
    },
    {
        key: '2',
        label: 'Skills',
        children: <p>{text}</p>,
    },

];
function SideBar({ onLanguageChange,  projectsList, selectedTags, setSelectedElement, skillsList, setSelectedSideBar, windowWidth}) {
    const [selected, setSelected] = useState("projects"); // Add this line
    const [projects, setProjects] = useState([]);
    const [skills, setSkills] = useState([]);
    const [selectedProjectFullName, setSelectedProjectFullName] = useState(null);
  const [language, setLanguage] = useState(Cookies.get('language') || 'de'); // Initialize language from cookie

  useEffect(() => {
    if(windowWidth < 600){
      setSelected(null);
      setSelectedSideBar(null);
    }
  }, []);

  useEffect(() => {
    const handleCookieChange = () => {
      const newLanguage = Cookies.get('language') || 'de';
      setLanguage(newLanguage); // Update language state when cookie changes
    };

    // Monitor cookie changes (polling or custom logic)
    const interval = setInterval(handleCookieChange, 1000); // Check every second

    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, []);



  useEffect(() => {
    var showProjects = [];
    if (selectedTags.length > 0) {
      for (let i = 0; i < projectsList.length; i++) {
        var projectTags = projectsList[i]["technic"];
        for (let j = 0; j < projectTags.length; j++) {
          if (selectedTags.includes(projectTags[j]["name"])) {
            showProjects.push(projectsList[i]);
            break;
          }
        }

      }
    } else {
      showProjects = projectsList;
    }
    setProjects(showProjects)

    showProjects = [];
    if (selectedTags.length > 0) {
      for (let i = 0; i < skillsList.length; i++) {
        var projectTags = skillsList[i]["technic"];
        for (let j = 0; j < projectTags.length; j++) {
          if (selectedTags.includes(projectTags[j]["name"])) {
            showProjects.push(skillsList[i]);
            break;
          }
        }

      }
    } else {
      showProjects = skillsList;
    }
    setSkills(showProjects)

  }, [selectedTags, projectsList, skillsList]);

    const projectNames = projects.map(project => ({
      short: project.shortTitle?.[language] || project.title?.[language],
      full: project.title?.[language],
      category: project.category,
      id: project.id,
    }));

    const handleProjectClick = (id) => {
      setSelectedElement([id, "Projects"]);
      if( windowWidth < 600){
        setSelected(null);
        setSelectedSideBar(null);
      }
      // You can also do something else here, like call a callback prop
    };


    const skillsNames = skills.map(skills => ({
      short: skills.shortTitle?.en || skills.title?.en,
      full: skills.title?.en,
      category: skills.category,
      id: skills.id,
    }));

    const handleSkillsClick = (id) => {
      setSelectedElement([id, "Skills"]);
      if( windowWidth < 600){
        setSelected(null);
        setSelectedSideBar(null);
      }
      // You can also do something else here, like call a callback prop
    };


    const handleSideBarChange = (key) => {
        if (key === selected){
            setSelected(null);
            setSelectedSideBar(null);
        } else {
            setSelected(key);
            setSelectedSideBar(key);
        }
    };
    const onChange = (key: string | string[]) => {
        console.log(key);
    };
    return (
        <>
            <div style={{ display: 'flex', position: 'fixed', top: '50px', left: 0, height: 'calc(100% - 50px)', zIndex: 999 }}>
                {/* Sidebar */}
                <div
                    id="sideBar"
                    style={{
                        height: '100%',
                        width: '50px',
                        backgroundColor: '#0B0E13',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        gap: '18px',
                        paddingLeft: '5px',
                        paddingRight: 0,
                    }}
                >

                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            cursor: 'pointer',
                            width: '100%',
                        }}
                        onClick={() => handleSideBarChange('projects')}
                    >

                        <div
                            style={{
                                width: 5,
                                height: 40,
                                background: selected === 'projects' ? '#E6B455' : 'transparent',
                                marginRight: 4,
                                borderRadius: 2,
                                transition: 'background 0.2s',
                            }}
                        />
                        <Tooltip title="List of Projects and Skills">
                            <img
                                src="/Projects.png"
                                alt="Projects Symbol"
                                style={{ minHeight: '40px', height: '40px' }}
                            />
                        </Tooltip></div>

                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            cursor: 'pointer',
                            width: '100%',
                        }}
                        onClick={() => handleSideBarChange('version')}
                    >

                        <div
                            style={{
                                width: 5,
                                height: 40,
                                background: selected === 'version' ? '#E6B455' : 'transparent',
                                marginRight: 4,
                                borderRadius: 2,
                                transition: 'background 0.2s',
                            }}
                        />


                        <Tooltip title="Github Repository">
                            <img
                                src="/Version.png"
                                alt="Versioning Symbol"
                                style={{ minHeight: '40px', height: '40px' }}
                            /></Tooltip>
                    </div>

                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            cursor: 'pointer',
                            width: '100%',
                        }}
                        onClick={() => handleSideBarChange('docker')}
                    >

                        <div
                            style={{
                                width: 5,
                                height: 40,
                                background: selected === 'docker' ? '#E6B455' : 'transparent',
                                marginRight: 4,
                                borderRadius: 2,
                                transition: 'background 0.2s',
                            }}
                        />
                        <Tooltip title="dockerhub Repository">
                            <img
                                src="/Container.png"
                                alt="Container Symbol"
                                style={{ minHeight: '38px', height: '38px' }}
                            /></Tooltip>
                    </div>
                </div>
                {/* Rectangle field to the right */}
                {selected !== null && (
                <div
                    style={{
                        width: windowWidth < 600 ? `${windowWidth - 50}px` : '200px', // Adjust width as needed
                        height: '100%',
                        backgroundColor: '#0B0E13', // Your desired color
                    }}
                >
                {selected === "projects" && (    
                    <div>
                    <p style={{ margin: 0, color: '#585c51' }}>EXPLORER</p>
                    <Collapse
                      style={{ backgroundColor: '#0B0E13', color: '#585c51' }}
                      items={[
                        {
                          key: '101',
                          label: language === "en" ? 'Projects' : 'Projekte',
                          children: (
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                              {projectNames.map((proj, idx) => (
                                <li
                                  key={proj.id}
                                  style={{
                                    cursor: 'pointer',
                                    color: proj.category === "work" ? '#519AA5' : '#5C9131',
                                    marginBottom: 4,
                                  }}
                                  onClick={() => handleProjectClick(proj.id)}
                                >
                                    {proj.category === "work" && <SettingOutlined style={{ marginRight: 4, height: 16, color:  '#519AA2'}} />}
                                    {proj.category === "study" && <BookOutlined style={{ marginRight: 4, height: 16, color:  '#5C9131'}} />}
                                  {proj.short}
                                </li>
                              ))}
                            </ul>
                          ),
                        },
                        {
                          key: '102',
                          label: language === "en" ? 'Skills' : 'Fähigkeiten',
                          children: (
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                              {skillsNames.map((proj, idx) => (
                                <li
                                  key={proj.id}
                                  style={{
                                    cursor: 'pointer',
                                    color: proj.category === "work" ? '#519AA5' : '#5C9131',
                                    marginBottom: 4,
                                  }}
                                  onClick={() => handleSkillsClick(proj.id)}
                                >
                                    {proj.category === "work" && <SettingOutlined style={{ marginRight: 4, height: 16, color:  '#519AA2'}} />}
                                    {proj.category === "study" && <BookOutlined style={{ marginRight: 4, height: 16, color:  '#5C9131'}} />}
                                  {proj.short}
                                </li>
                              ))}
                            </ul>
                          ),
                        }
                      ]}
                      defaultActiveKey={['1']}
                      onChange={onChange}
                    />
                    </div>
                    
                    )}
                {selected === "version" && (    
                    <div>
                    <p style={{ margin: 0, color: '#565B4E', marginBottom: '5px' }}>SOURCE CONTROL</p>
                    <a
                      href="https://github.com/fiebach"
                      style={{
                        color: '#E6B455',
                        display: 'flex',
                        alignItems: 'center',
                        textDecoration: 'none',
                        gap: '8px', // spacing between icon and text
                        fontSize: '18px', // adjust as needed
                      }}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <GithubOutlined style={{ fontSize: '22px', color: '#E6B455' }} />
                      Github Profil
                    </a>
                                        <a
                      href="https://git.rz.tu-bs.de/vinzenz.fiebach2"
                      style={{
                        color: '#E6B455',
                        display: 'flex',
                        alignItems: 'center',
                        textDecoration: 'none',
                        gap: '8px', // spacing between icon and text
                        fontSize: '18px', // adjust as needed
                      }}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <GitlabOutlined style={{ fontSize: '22px', color: '#E6B455', marginTop: '5px' }} />
                      GitLab Profil
                    </a>
                    </div>
                    )}
                {selected === "docker" && (    
                                        <div>
                    <p style={{ margin: 0, color: '#565B4E', marginBottom: '5px' }}>CONTAINERS</p>
                    <a
                      href="https://hub.docker.com/u/thegoldenphoenix"
                      style={{
                        color: '#E6B455',
                        display: 'flex',
                        alignItems: 'center',
                        textDecoration: 'none',
                        gap: '8px', // spacing between icon and text
                        fontSize: '18px', // adjust as needed
                      }}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <DockerOutlined style={{ fontSize: '22px', color: '#E6B455' }} />
                      Docker Hub Profil
                    </a>
                    </div>
                    )}



                </div>)}
            </div>
        </>
    );
}

export default SideBar;
